import { Directive } from "vue";

export const vDropdown: Directive = {
    mounted: (el: HTMLInputElement) => {
        const hiddenEl = el.querySelector("input[type=hidden]");
        const inputEl = el.querySelector("input.input-text-input");

        el.classList.remove("show-dropdown");

        el.addEventListener("click", () => {
            if (el.classList.contains("show-dropdown")) {
                el.classList.remove("show-dropdown");
            } else {
                el.classList.add("show-dropdown");
            }
        });

        el
            .querySelector(".input-dropdown-elements-inner")
            ?.addEventListener("click", (e) => {
                e.stopPropagation();
            });

        addListEventListener(el, hiddenEl, inputEl);
    },
    updated: (el: HTMLInputElement) => {
        const hiddenEl = el.querySelector("input[type=hidden]");
        const inputEl = el.querySelector("input.input-text-input");
        addListEventListener(el, hiddenEl, inputEl);
    },
};

const addListEventListener = (
    el: HTMLInputElement,
    hiddenEl: Element | null,
    inputEl: Element | null,
) => {
    el.querySelectorAll(".input-dropdown-elements-inner ul li").forEach(
        (element) => {
            element.addEventListener("click", (e) => {
                const dataset = e?.target?.dataset;
                let value = dataset.value;
                let valueText = dataset.name;

                if (typeof value === "string" || typeof value === "number") {
                    if (
                        typeof valueText !== "string" &&
                        typeof valueText !== "number"
                    ) {
                        valueText = "";
                    }

                    if (hiddenEl) {
                        hiddenEl.value = value;
                        inputEl.value = valueText;
                        var event = new Event("change");
                        inputEl.dispatchEvent(event);
                    } else {
                        inputEl.value = value;
                        var event = new Event("change");
                        inputEl.dispatchEvent(event);
                    }
                } else {
                    var event = new Event("change");

                    inputEl.dispatchEvent(event);
                }

                el.classList.remove("show-dropdown");
            });
        },
    );
};
